import EventBroker from "./scripts/eventBroker";

export const globalBus = new EventBroker("global")